/* ============================================================
   PDP enhancements: full-width customer stories + description clamp

   Two jobs, both desktop-only, both purely additive — if either
   bails the page is exactly what the Liquid rendered.

   1. CUSTOMER STORIES STRIP
      Builds a strip of customer story cards from the posters that
      cucu-ig-stories already rendered further down the page, and
      appends it to .cu-pdp as its own full-width grid row.

      It used to be appended into .cu-rail, which made it a slide
      inside the gallery column — 740px wide, four cards, boxed in
      beside the buy column and clipped by the rail's own
      overflow. As a direct child of .cu-pdp spanning 1 / -1 it
      runs the full width of the product area (1440px), fits eight
      cards, and sits below both columns so it never fights the
      sticky buy panel for space.

      It reads posters out of the section's DOM rather than taking
      its own copy of the clip list. Three things follow:
        - Zero new storage. The clips live once in Files.
        - Swapping clips in the editor updates this too.
        - Tapping a card calls .click() on the original, so the
          section's own player, lazy loader and pending-open replay
          all run untouched. No player logic is duplicated here.
      If the merchant removes the stories section, this renders
      nothing.

   2. DESCRIPTION CLAMP
      The buy column is position:sticky, so its height is the whole
      ballgame: anything past the viewport is unreachable while
      pinned. Measured on a live card-cover PDP the column was
      1703px against a 726px viewport — 655px of that was the
      merchant description, including a 480x270 GIF being upscaled
      to 656x369. Clamping the description to ~15 lines behind a
      Read more toggle (and capping its media in CSS) gives back
      roughly 470px, which is the difference between the buy panel
      reading as a pinned control and reading as a runaway column.
      Below 750px the column is not sticky and the clamp is off.
   ============================================================ */
(function () {
  var DESKTOP = '(min-width: 750px)';
  var MAX_CARDS = 8;
  var DESC_MAX = 264;

  /* ---------- 1. stories strip ---------- */
  function stories() {
    var pdp = document.querySelector('.cu-pdp-root .cu-pdp');
    var root = pdp && pdp.parentElement;
    var host = document.querySelector('cucu-stories');
    if (!pdp || !root || !host) return;
    if (root.querySelector(':scope > .cu-gs')) return;

    var cards = host.querySelectorAll('.cu-st__card');
    if (!cards.length) return;

    var strip = document.createElement('div');
    strip.className = 'cu-gs';

    var head = document.createElement('div');
    head.className = 'cu-gs__head';

    var label = document.createElement('p');
    label.className = 'cu-gs__label';
    var title = host.querySelector('.cu-st__title');
    label.textContent = title ? title.textContent.trim() : 'Caught in the wild';
    head.appendChild(label);

    var follow = host.querySelector('.cu-st__follow');
    if (follow && follow.getAttribute('href')) {
      var link = document.createElement('a');
      link.className = 'cu-gs__all';
      link.href = follow.getAttribute('href');
      link.textContent = follow.textContent.trim();
      link.rel = 'noopener';
      head.appendChild(link);
    }
    strip.appendChild(head);

    var grid = document.createElement('div');
    grid.className = 'cu-gs__grid';

    Array.prototype.slice.call(cards, 0, MAX_CARDS).forEach(function (card, i) {
      var poster = card.getAttribute('data-poster');
      if (!poster) return;

      var button = document.createElement('button');
      button.type = 'button';
      button.className = 'cu-gs__card';
      button.setAttribute('aria-label', 'Play customer story ' + (i + 1));

      var img = document.createElement('img');
      img.src = poster;
      img.loading = 'lazy';
      img.decoding = 'async';
      img.alt = '';
      img.width = 180;
      img.height = 320;
      button.appendChild(img);

      /* The section's own handle, so the card is attributable the
         same way it is in the rail below. */
      var handleEl = card.querySelector('.cu-st__handle') ||
        (card.parentElement && card.parentElement.querySelector('.cu-st__handle'));
      if (handleEl && handleEl.textContent.trim()) {
        var handle = document.createElement('span');
        handle.className = 'cu-gs__handle';
        handle.textContent = handleEl.textContent.trim();
        button.appendChild(handle);
      }

      button.addEventListener('click', function () {
        card.click();
      });

      grid.appendChild(button);
    });

    if (!grid.children.length) return;

    strip.appendChild(grid);

    /* SIBLING OF .cu-pdp, NOT A ROW INSIDE IT. As a third grid row it
       looked right until you scrolled: Chrome lets a sticky grid item
       travel to the bottom of the grid CONTAINER rather than stopping at
       the end of its own row, so the buy column ran 360px down over the
       strip. Outside the product grid, .cu-pdp bounds the sticky travel
       and the strip still inherits grid-column 2 of the page grid, so it
       keeps the full 1440px product-area width. */
    root.insertBefore(strip, pdp.nextSibling);
  }

  /* ---------- 2. description clamp ---------- */
  function description() {
    var desc = document.querySelector('.cu-pdp-root .cu-buy .cu-desc');
    if (!desc || desc.dataset.cuClamped) return;

    /* Media has to settle before the height means anything. */
    var pending = Array.prototype.filter.call(desc.querySelectorAll('img'), function (img) {
      return !img.complete;
    });
    if (pending.length) {
      var done = 0;
      var settle = function () {
        if (++done === pending.length) description();
      };
      pending.forEach(function (img) {
        img.addEventListener('load', settle, { once: true });
        img.addEventListener('error', settle, { once: true });
      });
      return;
    }

    if (desc.scrollHeight <= DESC_MAX + 60) return;

    desc.dataset.cuClamped = '1';
    desc.classList.add('cu-desc--clip');

    var more = document.createElement('button');
    more.type = 'button';
    more.className = 'cu-desc__more';
    more.textContent = 'Read more';
    more.setAttribute('aria-expanded', 'false');

    more.addEventListener('click', function () {
      var open = desc.classList.toggle('cu-desc--open');
      more.textContent = open ? 'Show less' : 'Read more';
      more.setAttribute('aria-expanded', open ? 'true' : 'false');
    });

    desc.insertAdjacentElement('afterend', more);
  }

  function init() {
    if (!window.matchMedia(DESKTOP).matches) return;
    stories();
    description();
  }

  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);

  /* The editor re-renders a section on every setting change, which
     destroys the cards this reads from. Rebuild when that happens. */
  document.addEventListener('shopify:section:load', init);
})();
